export const generateSessionId = () => Date.now().toString();
